import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import { Stack, Typography } from "@mui/material";

const InvestorCommunicationPortalPreviewNote = () => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "center", alignSelf: "flex-start" }}>
    <VisibilityIcon color="primary" />
    <Typography color="textSecondary">This is what investors see in the portal.</Typography>
  </Stack>
);

export default InvestorCommunicationPortalPreviewNote;
